// This file should only contain action type constants.

export const SET_INCENTIVES = 'SET_INCENTIVES';
export const SET_MODAL = 'SET_MODAL';
export const VCDA_ERROR = 'VCDA_ERROR';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
export const SET_ACCOUNT = 'SET_ACCOUNT';



// WEBPACK FOOTER //
// ./src/actions/types.js